const digest = '1d4d3db5841840ac3494234db4bcee46ae4e2f72663708527795a9376d95e0f8';
const css = `._ErrorLayout_aipo3_1{margin:0 auto}._main_aipo3_5{margin:0 auto;max-width:1000px;padding:10px;width:100%}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'ErrorLayout': '_ErrorLayout_aipo3_1', 'main': '_main_aipo3_5' };
export const ErrorLayout = '_ErrorLayout_aipo3_1';
export const main = '_main_aipo3_5';
export { css, digest };